/**
 * The statuses a notification can carry, shared by the create/edit dialog (the
 * dropdown), the list (the filter tabs) and the row chips — so adding one here adds
 * it everywhere, and a status can never exist that the list has no tab for.
 *
 * Two different filters apply, so the statuses do different work in each:
 *   - the in-app bell and getActiveNotifications deliver only 'Active'
 *   - the branch pull endpoints (Get_notifications) return everything except 'Closed',
 *     which is what their callback sets once a branch has taken the alert
 */
export const NOTIFICATION_STATUSES = [
    { label: 'Active',   value: 'Active',   icon: 'pi pi-check-circle', tone: 'success'   },
    { label: 'Inactive', value: 'Inactive', icon: 'pi pi-times-circle', tone: 'danger'    },
    { label: 'Read',     value: 'Read',     icon: 'pi pi-eye',          tone: 'info'      },
    { label: 'Restart',  value: 'Restart',  icon: 'pi pi-replay',       tone: 'warning'   },
    { label: 'Closed',   value: 'Closed',   icon: 'pi pi-lock',         tone: 'secondary' }
];

/** Dropdown options — label/value only. */
export const STATUS_OPTIONS = NOTIFICATION_STATUSES.map(({ label, value }) => ({ label, value }));

/** Older rows were written as 'InActive'; treat that as 'Inactive' everywhere. */
export const normalizeStatus = (status) => {
    const value = String(status || '').trim();
    return value.toLowerCase() === 'inactive' ? 'Inactive' : value;
};

export const statusTone = (status) => NOTIFICATION_STATUSES.find((s) => s.value === normalizeStatus(status))?.tone || 'secondary';

export const countByStatus = (rows, status) => rows.filter((row) => normalizeStatus(row.status) === status).length;
